import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=f0503fa6&scoped=true&"
import script from "./PointList.vue?vue&type=script&lang=js&"
export * from "./PointList.vue?vue&type=script&lang=js&"
import style0 from "./PointList.vue?vue&type=style&index=0&id=f0503fa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0503fa6",
  null
  
)

export default component.exports